module.exports = __webpack_public_path__ + "media/images/heavy-rain-dca856aad17c79ca995d777a78026d3a.svg";